<div class="page">
  <div class="page__container">
    <h1 class="page__title h2" translate>studio_ask</h1>
    <div class="my-5 d-flex justify-content-around">
      <p [innerHTML]="'studio_ask_info' | translate"></p>
      <span [inlineSVG]="'assets/images/icons/menu/icon-rcp.svg'" placement="right" class="info-icon  studio-icon me-1"></span>
    </div>
  </div>
</div>
